module.exports = __webpack_public_path__ + "assets/img/userManual.1792c08e.jpg";